<template>
  <div class="payment-cards">
    <nuxt-img
      src="/footer/footer-mir.svg"
      alt="Mir"
      width="66"
      height="18"
      loading="lazy"
    />

    <nuxt-img
      src="/footer/footer-visa.svg"
      alt="Visa"
      width="56"
      height="18"
      loading="lazy"
    />

    <nuxt-img
      src="/footer/footer-master-card.svg"
      alt="MasterCard"
      width="30"
      height="18"
      loading="lazy"
    />
  </div>
</template>

<style lang="scss" scoped>
.payment-cards {
  display: flex;
  gap: 32px;
  align-items: center;
}
</style>
